var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
var TAB_GROUP = "flex flex-row";
export var TabGroup = function (_a) {
    var children = _a.children;
    return _jsx("div", __assign({ className: TAB_GROUP }, { children: children }), void 0);
};
